import { render, staticRenderFns } from "./AccountOverviewOrders.vue?vue&type=template&id=e97e377c&"
import script from "./AccountOverviewOrders.vue?vue&type=script&lang=js&"
export * from "./AccountOverviewOrders.vue?vue&type=script&lang=js&"
import style0 from "./AccountOverviewOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports